import { createLoadableState } from '@/utils/store/concerns/loadable/state'

export default () =>
  createLoadableState({
    program: {},
    isLoading: false
  })
